var _style, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgError(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 340.8 340.8",
    style: {
      enableBackground: "new 0 0 340.8 340.8"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#EE3A3A;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M170.4,0.9C76.9,0.9,0.9,76.9,0.9,170.4S77,339.9,170.4,339.9s169.5-76.1,169.5-169.5S263.9,0.9,170.4,0.9z  M315.2,170.4c0,79.9-65,144.8-144.8,144.8s-144.8-65-144.8-144.8c0-79.9,65-144.8,144.8-144.8S315.2,90.5,315.2,170.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M237,115.2c0-3.3-1.3-6.4-3.5-8.7c-2.2-2.2-5.4-3.5-8.7-3.5s-6.4,1.3-8.7,3.5l-45.7,45.7l-45.7-45.7 c-2.2-2.2-5.4-3.5-8.7-3.5s-6.4,1.3-8.7,3.5c-2.2,2.2-3.5,5.4-3.5,8.7c0,3.3,1.3,6.4,3.5,8.7l45.7,45.7L107.3,215 c-2.2,2.2-3.5,5.4-3.5,8.7s1.3,6.4,3.5,8.7c2.2,2.2,5.4,3.5,8.7,3.5c3.2,0,6.5-1.3,8.7-3.5l45.7-45.7l45.7,45.7 c2.2,2.2,5.4,3.5,8.7,3.5c3.2,0,6.5-1.3,8.7-3.5s3.5-5.4,3.5-8.7s-1.3-6.4-3.5-8.7l-45.7-45.4l45.7-45.7 C235.7,121.6,237,118.5,237,115.2z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgError);
export default __webpack_public_path__ + "static/media/error.547b7e56b9cecfb932e10d89f91e6c48.svg";
export { ForwardRef as ReactComponent };